export default {
	materialUnavailable: {
		singleLine1: "Il materiale di questo articolo non è disponibile.",
		singleLine2: "Clicchi qui per modificare il materiale.",
		assemblyLine1:
			"Il materiale di uno o più articoli singoli di questo assemblaggio non è disponibile.",
		assemblyLine2: "Clicchi qui per visualizzare gli articoli singoli.",
	},
	cad: {
		tooltipLine1: "Apre il modello CAD nel browser.",
		tooltipLine2:
			"Nell'editor CAD integrato di Blexon può inserire / modificare filettature, svasature, incisioni, cordoni di saldatura, ecc.",
		tooltipLine3: "Inoltre può controllare le dimensioni, visualizzare i messaggi e correggere le cause degli errori.",
	},
	features: {
		label: "Lavorazioni",
		basePrimed: "- preverniciato",
		engraving: "Incisione",
	},
	info: {
		articleNumberLabel: "N. articolo:",
		blexonNumberLabel: "N. Blexon:",
		materialTypeLabel: "Materiale:",
		thicknessLabel: "Spessore:",
		topSideLabel: "Lato superiore",
		bottomSideLabel: "Lato inferiore",
		quantityInAssemblyLabel: "Quantità nell'assemblaggio:",
		dimensionsLabel: "LxLxA:",
		weightLabel: "Peso:",
		deburringLabel: "Sbavatura:",
		powderCoatingLabel: "Verniciatura a polvere:",
		zincCoatingLabel: "Zincatura:",
		certificateLabel: "Certificato:",
		certificateInfoTooltip: "Ulteriori informazioni sul certificato",
		noCoating: "Nessuna",
		materialDivers: "Materiale: Vari",
		additionalDesignationGrinded: " / Levigato / Pellicola",
		additionalDesignationAnodized: " / Pellicola",
		additionalDesignationRibbed: " / Scanalato",
	},
	assembly: {
		moreText: "altro...",
		showSubarticlesButton: "Mostra articoli singoli",
		showSubarticlesTooltip: "Mostra tutti gli articoli di questo assemblaggio.",
		calculatingMessage: "Alcuni articoli di questo assemblaggio sono attualmente in fase di calcolo.",
		noValidBodies:
			"L'assemblaggio non contiene solidi validi. Probabilmente i solidi sono aperti oppure definiti solo come superfici.",
		checkSubarticlesHint:
			"Clicchi su 'Mostra articoli singoli' per vedere lo stato dei singoli articoli ed eseguire su di essi le azioni necessarie.",
	},
	state: {
		errorHint:
			"Apra l'articolo nel CAD e verifichi l'errore, oppure lo invii al nostro helpdesk per un'analisi gratuita.",
		infoHint:
			"La preghiamo di aprire l'articolo nel CAD e definire cosa fare con le lavorazioni rilevate.",
		inReview: "In verifica",
		ok: "OK",
		warning: "Avviso",
		error: "Errore",
		new: "Nuovo",
		actionRequired: "Azione richiesta",
		unclear: "Non chiaro",
	},
	cart: {
		quantityPlaceholder: "Quantità",
		addToCartButton: "Nel carrello",
		addToCartTooltip: "Aggiunge l'articolo al carrello.",
		addedToCartSnackbar: "{quantity} pezzi aggiunti al carrello.",
		assemblyPartCannotOrder:
			"Gli articoli che fanno parte di un assemblaggio non possono essere ordinati singolarmente.",
		powderCoatingEngravingConflictLine1:
			"Gli articoli con verniciatura a polvere e incisione non possono essere ordinati.",
		powderCoatingEngravingConflictLine2:
			"L'incisione verrebbe completamente coperta dalla verniciatura a polvere.",
		powderCoatingEngravingConflictLine3:
			"Rimuova l'incisione oppure la verniciatura a polvere, per poter ordinare l'articolo.",
		cannotBeProducedInRegion: "Al momento l'articolo non può essere ordinato in {region}.",
	},
	buttons: {
		openCad: "Visualizza / modifica modello CAD",
		sendToHelpdesk: "Invia all'helpdesk",
		sendToHelpdeskTooltipLine1: "L'articolo viene inviato al nostro helpdesk e analizzato gratuitamente.",
		sendToHelpdeskTooltipLine2: "Sarà informato non appena avremo elaborato il Suo articolo.",
		blexonize: "Blexonizzare l'articolo",
		blexonizeTooltipLine1: "L'articolo non è ancora stato blexonizzato con la versione più recente.",
		blexonizeTooltipLine2:
			"Per ordinare l'articolo, verificarlo o modificarlo nel CAD, clicchi qui.",
	},
	messages: {
		checkCartMembershipError:
			"Al momento non è possibile verificare se l'articolo viene utilizzato in una distinta base.",
	},
	header: {
		selectForMultiActionTooltip:
			"Selezioni per un'azione multipla. Le azioni possibili vengono mostrate sopra.",
		contextMenuTooltip: "Apre il menu contestuale dell'articolo.",
		edit: "Modifica",
		delete: "Elimina",
		unlock: "Sblocca",
		lock: "Blocca",
	},
	pricelist: {
		openTooltip: "Apre il listino prezzi dell'articolo.",
		button: "Listino prezzi",
		pricesNotCalculatedLine1: "Non è stato possibile calcolare i prezzi per questo articolo.",
		pricesNotCalculatedLine2: "Invii l'articolo al nostro helpdesk per un'analisi gratuita.",
		priceInfoTooltip: "Scopra qui come ottenere i Suoi articoli a un prezzo ancora più vantaggioso.",
		priceHintLabel: "Nota sul prezzo",
		pricePerUnitMulti: "Prezzo / pz. [{currency}]",
		pricePerUnitSingle: "Prezzo/pz. [{currency}]",
		quantityLabel: "Quantità",
		fromQuantity: "da {quantity}",
		addQuantityToCartTooltip: "{quantity} pezzi nel carrello",
		hintTitle: "Il prezzo finale, sconto quantità incluso, è visibile nel carrello.",
		hintText:
			"Più articoli con le stesse lavorazioni o con lo stesso materiale comportano una riduzione di prezzo. Per calcolare il prezzo definitivo, composti un carrello e ottenga in pochi secondi un'offerta comprensiva di data di consegna.",
		loadError: "Non è stato possibile caricare i prezzi per l'articolo.",
	},
};
